module.exports = __webpack_public_path__ + "static/media/calendar.7696e648.svg";